import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export function useDeleteUser() {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/users/" + id);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries(["allUsers"]),
    });

    return query;
}
